module.exports = "/images/card-image-5.jpg?677b3fc1ac8287624d8071bc811d04a2";